import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=53e330f3"
import script from "./textarea.js?vue&type=script&lang=js&external"
export * from "./textarea.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports